// extracted by mini-css-extract-plugin
export var messageSideLeft = "_jr-1";
export var messageSideRight = "_jr-2";
export var subscribeToBackInStockBubbleContainer = "_jr-0";